export enum TableBorder {
  ALL = 'all',
  EMPTY = 'empty',
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  DASH = 'dash'
}

export enum TdBorder {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left'
}

export enum TdSlash {
  FORWARD = 'forward', // 正斜线 /
  BACK = 'back' // 反斜线 \
}
